export default "__VITE_ASSET__Dzbb$o_V__"